import Nullstack from 'nullstack';
export default function IconComponentsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-components-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 12l3 3l3 -3l-3 -3z"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M9 18l3 3l3 -3l-3 -3z"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}